import React from 'react'

import { TestSuiteRisks } from 'components/test-suites/forms/TestSuiteRisks'
import { TestSuiteUnderstandingScoreCalculation } from 'components/test-suites/forms/TestSuiteUnderstandingScoreCalculation'

export const CreateTestSuiteEditRisks: React.FC = () => (
  <>
    <TestSuiteRisks />
    <TestSuiteUnderstandingScoreCalculation />
  </>
)
